import React, { FC, MouseEvent } from 'react';

import { Carousel } from 'components_common/customized_modules/nuka-carousel/carousel';
import { getImageAlt } from 'helpers/seoHelper';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { Product } from 'models/product';

import { ImageSwipe } from '../../types/Imageswipe';

export const MainImage: FC<{
  gridArea: string;
  handleCarouselSlideChange: (idx: number) => void;
  handlePhotoSwipeOpen: (e: MouseEvent<HTMLElement>) => void;
  imageSwipe: ImageSwipe;
  product: Product;
}> = ({ gridArea, handleCarouselSlideChange, handlePhotoSwipeOpen, imageSwipe, product }) => {
  const { withCDN } = useUrlBuilder();

  const { brand, images, model, storeColor } = product;

  const mobileCarouselImages = images.map(image => (
    <img
      alt={getImageAlt({ brandName: brand.name, color: storeColor, model })}
      data-cy="carousel-image-product"
      onClick={handlePhotoSwipeOpen}
      onError={e => {
        const elementTarget = (e.target as unknown) as { src: string };
        elementTarget.src = withCDN('mkt/icon/no_image.png');
      }}
      src={image.medium}
      style={{ minHeight: '350px' }}
    />
  ));

  return (
    <div className="main-image">
      <span
        className="desktop"
        data-options="hint: always; rightClick:true; zoomPosition: inner; cssClass: no-expand-thumbnails;"
        onClick={handlePhotoSwipeOpen}
      >
        <img
          alt={getImageAlt({ brandName: brand.name, color: storeColor, model })}
          className="current-image"
          itemProp="image"
          src={images[imageSwipe.currentImageIndex].medium}
        />
      </span>

      <div className="mobile">
        <Carousel
          afterSlide={handleCarouselSlideChange}
          displayButtons={['SlideIndicators', 'ZoomButton']}
          dragging
          easing="easeInOutSine"
          edgeEasing="easeInOutSine"
          imageMaxHeight="350px"
          imageMaxWidth="520px"
          imageWidth="100%"
          initialSlideHeight={350}
          openPhotoSwipe={handlePhotoSwipeOpen}
          slideIndex={imageSwipe.currentImageIndex}
          speed={200}
          swiping
          wrapAround
        >
          {mobileCarouselImages}
        </Carousel>
      </div>

      <style jsx>{`
        .main-image {
          display: flex;
          justify-content: center;
          grid-area: ${gridArea};

          // making carousel ignore padding
          width: auto;
          margin: 0 -20px;
        }
        @media (min-width: 1024px) {
          .main-image {
            justify-content: start;
            padding: 40px;
            margin: 0;
          }
        }

        span {
          cursor: zoom-in;
        }

        .desktop .current-image {
          max-width: 390px;
        }

        .mobile {
          width: 100%;
        }
      `}</style>
    </div>
  );
};
